module.exports = __webpack_public_path__ + "img/testimonial-who-2.b2a0790.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/testimonial-who-2.png
// module id = ./assets/img/testimonial-who-2.png
// module chunks = 2 3 4 5 6